<template lang="html">
    <div>
        <p>Êtes-vous sûr de vouloir supprimer les produits suivants :</p>
        <ul>
            <li v-for="project in $store.state.datatable.products.selected">
                {{ project.label }}
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                title:          'Suppression de produits',
                icon:           'delete',
                warning:        true
            }
        },

        methods: {
            onClose() {
                this.$eventHub.$emit('close-modal')
            },

            onValidate() {
                this.$store.state.datatable.products.selected.forEach((item, index) => {
                    this.axios.delete(`/api/products/${item.id}`)
                        .then(response => {
                            this.$eventHub.$emit('close-modal')
                            this.$eventHub.$emit('reload-list')
                        })
                        .catch(err => console.log(err.response.data))
                })
            }
        },
    }
</script>

<style lang="stylus" scoped>
    div {
        padding: 1rem 4rem

        ul {
            margin-left: 3rem
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/products/list/Delete.vue